module.exports = __webpack_public_path__ + "nana_mint_tea_mockup_paper.png?26e22b2b1a66e02205a987854e8f247e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/nana_mint_tea_mockup_paper.png
// module id = 78
// module chunks = 0